// src/services/AmenityServices.js
import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

// Obtener una amenidad por su ID
export const getAmenityById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/amenity/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Crear una nueva amenidad
export const createAmenity = async (amenity) => {
  try {
    if (!amenity.glbCode || amenity.glbCode === '') {
      amenity.glbCode = amenity.slug;
    }
    const response = await axiosInstance.put(`${API_URL}/amenity`, amenity);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Eliminar una amenidad
export const deleteAmenity = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/amenity/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Actualizar una amenidad existente
export const updateAmenity = async (id, amenity) => {
  try {
    amenity.id = id;
    if (!amenity.glbCode || amenity.glbCode === '') {
      amenity.glbCode = amenity.slug;
    }
    const response = await axiosInstance.put(`${API_URL}/amenity`, amenity);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
